import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button, Table, TableRow, TableCell, TableHead, TableBody } from '@availity/element';

const MethodRow = ({ ...props }) => {
  const { method = {}, removeMethod, showRemoveButtons } = props;
  const { methodIndex, type, number } = method;

  const translatedType = useMemo(() => {
    let output = type;

    const lowercaseType = type.toLowerCase();
    switch (lowercaseType) {
      case 'sms': {
        output = 'Text';
        break;
      }
      case 'tts': {
        output = 'Voice';
        break;
      }
      case 'totp': {
        output = 'Authenticator';
        break;
      }
      default:
    }

    return output;
  }, [type]);

  return (
    <TableRow>
      <TableCell>{translatedType}</TableCell>
      <TableCell>{number === 0 ? 'No details' : number}</TableCell>
      <TableCell>
        {showRemoveButtons && (
          <Button color="tertiary" onClick={() => removeMethod(methodIndex)}>
            Remove
          </Button>
        )}
      </TableCell>
    </TableRow>
  );
};

MethodRow.propTypes = {
  method: PropTypes.object.isRequired,
  removeMethod: PropTypes.func.isRequired,
  showRemoveButtons: PropTypes.bool.isRequired,
};

const TwoFAMethodTable = ({ ...props }) => {
  const { methodArray = [], removeMethod } = props;
  const showRemoveButtons = useMemo(() => methodArray?.length > 1, [methodArray]);

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Method</TableCell>
          <TableCell>Details</TableCell>
          <TableCell>Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {methodArray.map((method, index) => {
          const keyToUse = `method-${index}`;

          return (
            <MethodRow
              key={keyToUse}
              method={method}
              removeMethod={removeMethod}
              showRemoveButtons={showRemoveButtons}
            />
          );
        })}
      </TableBody>
    </Table>
  );
};

TwoFAMethodTable.propTypes = {
  methodArray: PropTypes.array,
  removeMethod: PropTypes.func.isRequired,
};

export default TwoFAMethodTable;
